<template>
  <slot></slot>
</template>
<script>
import {mapState} from 'vuex';
import {useApplePaySdk} from '@/composables/apple-pay-sdk.js';

export default {
  name: 'CartContainer',
  setup() {
    useApplePaySdk();
  },
  computed: {
    ...mapState('backend', ['isUserLoggedIn']),
  },
};
</script>
